var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC1RollerShutter180Rotation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.34 20h39.82l-4.81 6h-40l4.99-6zm-5 16h40l4.81-6H34.34l-5 6zm0 10h40l4.81-6H34.34l-5 6zm0 10h40l4.81-6H34.34l-5 6zM5.88 39.33A15 15 0 0120 24.42v5.49l7.5-7.5-7.5-7.5v5.51a18.95 18.95 0 00.83 37.87v-4A15 15 0 015.88 39.33z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/C1_Roller_shutter_180_rotation.12619e9e.svg";
export { SvgC1RollerShutter180Rotation as ReactComponent };